__webpack_public_path__ = window.REBELMOUSE_BASE_ASSETS_URL;

import eventBus from "./context/eventBus";
import intersectionObserverProvider from "./context/intersectionObserverProvider";
import translateParamsToObject from "./utils/translateParamsToObject";
import startApp from "./app";

function createContext(getParams, bootstrap) {
    const context = {
        intersectionObserverProvider,
        eventBus,
        settings: bootstrap,
        pathParams: translateParamsToObject(getParams),
    };
    return context;
}

export default function onDomReady() {
    startApp(createContext(window.location.search, window.REBELMOUSE_BOOTSTRAP_DATA));
}
